import { Table, Typography } from 'antd';
import React from 'react';
import { PCodeDelta } from 'services/pcodes/types';
import styled from 'styled-components';
import getLocalTime from 'utils/get-local-time';
const { Text } = Typography;

const StyledText = styled(Text)`
  display: block;
`;

const StyledTable = styled(Table)`
  .ant-table-body {
    max-height: calc(100vh - 390px) !important;
  }
  tr.NEW {
    background-color: #d9f7be;
  }
`;

const renderDelta = (oldValue: string, newValue: string, crudInfo: string) => {
  if (crudInfo === 'NEW') {
    return newValue;
  }
  // Updated
  if (oldValue !== newValue) {
    return (
      <>
        <StyledText delete>{oldValue}</StyledText>
        <StyledText mark>{newValue}</StyledText>
      </>
    );
  }
  return oldValue;
};

export const pcodesDeltaColumns = [
  {
    title: '',
    dataIndex: 'id',
    align: 'center',
    width: 40,
    render: (_: unknown, record: PCodeDelta, idx: string) => idx + 1,
  },
  {
    title: 'Code',
    dataIndex: 'code',
    width: 150,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    render: (_: unknown, record: PCodeDelta) =>
      renderDelta(record.name, record.updatedName, record.crudInfo),
  },
  {
    title: 'Type',
    dataIndex: 'hyperionType',
    width: 150,
    render: (_: any, record: PCodeDelta) =>
      renderDelta(
        record.hyperionType,
        record.updatedHyperionType,
        record.crudInfo
      ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    width: 120,
    render: (_: any, record: PCodeDelta) =>
      renderDelta(record.status, record.updatedStatus, record.crudInfo),
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    width: 100,
    render: (_: any, record: PCodeDelta) =>
      renderDelta(
        getLocalTime(record.startDate, 'DD/MM/YYYY'),
        getLocalTime(record.updatedStartDate, 'DD/MM/YYYY'),
        record.crudInfo
      ),
  },
  {
    title: 'End Date',
    dataIndex: 'endDate',
    width: 100,
    render: (_: any, record: PCodeDelta) =>
      renderDelta(
        getLocalTime(record.endDate, 'DD/MM/YYYY'),
        getLocalTime(record.updatedEndDate, 'DD/MM/YYYY'),
        record.crudInfo
      ),
  },
  {
    title: 'Project Owner / Process Architect',
    dataIndex: 'projectOwner',
    render: (_: unknown, record: PCodeDelta) =>
      renderDelta(record.projectOwner, record.updatedProjectOwner, record.crudInfo),
  },
  {
    title: 'Project (Business) Manager / Process Owner',
    dataIndex: 'projectManager',
    render: (_: unknown, record: PCodeDelta) =>
      renderDelta(record.projectManager, record.updatedProjectManager, record.crudInfo),
  },
  {
    title: 'Process / Product Leader',
    dataIndex: 'processLeader',
    render: (_: unknown, record: PCodeDelta) =>
      renderDelta(record.processLeader, record.updatedProcessLeader, record.crudInfo),
  },
];

export interface IPCodesDeltaTable {
  deltaData: Array<PCodeDelta>;
}

const PCodesDeltaTable = ({ deltaData }: IPCodesDeltaTable) => {
  return (
    <StyledTable
      rowClassName={(record: any) => record.crudInfo}
      // @ts-ignore
      columns={pcodesDeltaColumns}
      dataSource={deltaData}
      size="small"
      pagination={false}
      scroll={{ y: 600 }}
    />
  );
};

export default PCodesDeltaTable;
